import { render, staticRenderFns } from "./SchoolTimeTableDetails.vue?vue&type=template&id=4785551c&"
import script from "./SchoolTimeTableDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./SchoolTimeTableDetails.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SchoolTimeTableDetails.vue?vue&type=style&index=0&id=4785551c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports